var _style, _rect, _circle, _line, _line2, _line3, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRelativeHumidityActuator({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFF;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#FFFFFF;stroke-width:0.15;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 4.7,
    className: "st0",
    width: 10.6,
    height: 6.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 9.3,
    cy: 9.8,
    r: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.1,
    y1: 8,
    x2: 12.2,
    y2: 8
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 12.9,
    y1: 8,
    x2: 13.9,
    y2: 8
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 14.5,
    y1: 8,
    x2: 15.6,
    y2: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.1,7.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.6,7.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.8,5.5 3.8,6.3 3.8,7.2  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.5,
    y1: 6.3,
    x2: 3.8,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.4,5.5c0,0.6,0,1.1,0,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5,6.4c0.4,0,0.5,0,0.5,0.1c0,0.2,0.1,0.3-0.3,0.5L5.1,7.4h0.5"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 6.6,
    cy: 6.4,
    rx: 0.5,
    ry: 0.8
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 2.5,
    cy: 5.9,
    r: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 3.1,
    cy: 6.5,
    r: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2.4,6.8l0.8-1.2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRelativeHumidityActuator);
export default __webpack_public_path__ + "static/media/RelativeHumidityActuator.30304e8165b836a660e9a63d1790cc67.svg";
export { ForwardRef as ReactComponent };